<form [formGroup]="editClassForm" *ngIf="!isLoading else loadingView">
    <acabim-form-block
            labelWidth="10"
            [labelAlign]="'right'"
            [shortFields]="true"
            [colonize]="true">
        <acabim-form-input-wrapper *ngIf="classDetail">
            <acabim-form-input-label>Status</acabim-form-input-label>
            <acabim-form-input-content>
                <p-checkbox formControlName="status" [binary]="true"></p-checkbox>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper *ngIf="classDetail">
            <acabim-form-input-label>Class Id</acabim-form-input-label>
            <acabim-form-input-content> {{classDetail ? classDetail.id : ''}}</acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Identifier</acabim-form-input-label>
            <acabim-form-input-content>  
                <input type="number" formControlName="identifier" id="identifier"
                placeholder="Enter a class identifier"/>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Name</acabim-form-input-label>
            <acabim-form-input-content>  
                <input type="text" formControlName="className" id="className"
                placeholder="Enter a class name"/>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Description</acabim-form-input-label>
            <acabim-form-input-content [longField]="true">
                <acabim-text-area class="w-100" [formGroup]="editClassForm" controlName="description"></acabim-text-area>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
   </acabim-form-block> 
</form>

<div class="cas-action-buttons">
    <button class="cas-button-action cas-button-right" (click)="onSubmit()">UPDATE</button>
</div>

<p-toast position="center"></p-toast>
<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
